import { responsiveBreakpointsPx } from '@/constants/responsiveness';
import { useMediaQuery } from '@/hooks/useMediaQuery';

export const useViewportWidthName = (): keyof typeof responsiveBreakpointsPx => {
    const isMd = useMediaQuery(`(min-width: ${responsiveBreakpointsPx.md}px)`);
    const isLg = useMediaQuery(`(min-width: ${responsiveBreakpointsPx.lg}px)`);
    const isNavTablet = useMediaQuery(`(min-width: ${responsiveBreakpointsPx['nav-tablet']}px)`);
    const isXl = useMediaQuery(`(min-width: ${responsiveBreakpointsPx.xl}px)`);

    if (isXl) return 'xl';
    if (isNavTablet) return 'nav-tablet';
    if (isLg) return 'lg';
    if (isMd) return 'md';
    return 'sm';
};
